
import { Component, Vue, Watch } from 'vue-property-decorator'
import { TransTopReq, GetAllGameList } from '@/api/admin/risk'
import moment from 'moment'
import publicTable from '@/views/components/publicTable.vue'
@Component({
  components: {
    publicTable
  }
})
export default class SubGameRoom extends Vue {
  loading: boolean = false
  TransTopReqTimer: any
  select = {
    GameType_List: [
      { name: 'PVE游戏', value: 1 },
      { name: 'PVP游戏', value: 2 },
      { name: '捕鱼游戏', value: 3 },
      { name: '红包游戏', value: 4 },
      { name: '单机游戏', value: 5 },
      { name: '百胜游戏', value: 8 },
      { name: '外接游戏', value: 9 }
    ],
    dataTime: [
      (this as any).getCurrentZeroDay(),
      new Date(new Date().setHours(23, 59, 59, 59))
    ]
  }
  colorList = [
    '#145b7d',
    '#72baa7',
    '#78331e',
    '#f05b72',
    '#f58220',
    '#4e72b8',
    '#f26522',
    '#ed1941',
    '#694d9f',
    '#00a6ac',
    '#225a1f',
    '#f2eada',
    '#ef5b9c',
    '#2a5caa',
    '#008792',
    '#1b315e',
    '#f7acbc',
    '#11264f',
    '#ea66a6'
  ]
  tableTotal: any = {
    game_id: -10,
    game_name: '合计',
    _disableExpand: true,
    sub_user_num: 0,
    bet_user_rate: 1,
    bet_point: 0,
    bet_point_rate: 1,
    back_point: 0,
    percent_point: 0,
    loss_point: 0,
    loss_rate: 0,
    winner_rate: 0,
    winner_user: 0,
    loser_user: 0,
    user_point: 0,
    round_num: 0,
    play_num: 0
  }
  imageData = {
    show: false,
    app_name: '',
    ref: 'subVChartImage',
    checkColumn: 'sub_user_num',
    selectColumn: this.getColumn(false).splice(0, 3),
    options: ['#32CD32', 'rgb(244, 128, 36)'],
    extend: {
      series: {
        label: {
          show: true,
          position: 'top',
          formatter: v => {
            if (v.seriesName.includes('比')) {
              return (v.value * 100).toFixed(2) + '%'
            } else {
              return v.value
            }
          }
        },
        itemStyle: {
          normal: {
            color: params => {
              return this.colorList[params.dataIndex % this.colorList.length]
            }
          }
        },
        barMaxWidth: 70
      }
    },
    chartSettings: {
      labelMap: {
        sub_user_num: '投注人数',
        round_num: '游戏人次',
        bet_user_rate: '投注人数占比',
        bet_point: '投注金额',
        bet_point_rate: '投注金额占比',
        user_point: '人均投注金额',
        play_num: '人均游戏次数',
        back_point: '返奖金额',
        percent_point: '税收金额',
        loss_point: '游戏盈亏',
        loss_rate: '盈亏投注比',
        winner_rate: '赢钱人数占比'
      },
      yAxisType: ['percent']
    },
    chartData: {
      columns: ['game_name', 'sub_user_num'],
      rows: []
    }
  }
  //表单数据
  table = {
    params: {
      platform: 0,
      app_id: 0,
      stime: 0,
      etime: 0,
      gtype: 0
    },
    platCheckList: [],
    app_ids: [],
    data: [],
    dataObj: {},
    columns1: this.getColumn(false),
    columns: this.getColumn(true)
  }
  gameId: number = 0

  updatePlatCheckList() {
    this.table.app_ids = []
  }
  getColumn(isExpand) {
    return [
      isExpand
        ? {
            type: 'expand',
            width: 50,

            // fixed: "left",
            align: 'center',
            render: (h, params) => {
              return h(publicTable, {
                props: {
                  row: params.row.data,
                  columns: this.table.columns1
                }
              })
            }
          }
        : {
            align: 'center',
            width: 50,
            // fixed: "left",
            render: (h, params) => {
              return h('span', '')
            }
          },
      {
        type: 'index',
        title: '序号',
        width: 55,
        align: 'center',
        indexMethod: (el, val) => {
          if (el.game_id == -10) {
            return ''
          } else {
            return el._index + 1
          }
        }
      },
      {
        key: 'game_name',
        align: 'center',
        width: 125,
        resizable: true,
        render: (h, params) => {
          if (!params.row.app_name) {
            return h('span', params.row.game_name)
          } else {
            return h('span', params.row.app_name)
          }
        },
        renderHeader: (h, params) =>
          (this as any).renderHeader(
            h,
            '游戏名称',
            '该子游戏在游戏内显示的游戏名称信息'
          )
      },
      {
        key: 'round_num',
        align: 'center',
        sortable: 'custom',
        width: 125,
        resizable: true,
        renderHeader: (h, params) =>
          (this as any).renderHeader(
            h,
            '游戏人次',
            '筛选时间内，筛选的子游戏的游戏人次汇总'
          )
      },
      {
        key: 'sub_user_num',
        align: 'center',
        sortable: 'custom',
        width: 125,
        resizable: true,
        renderHeader: (h, params) => {
          return (this as any).renderHeader(
            h,
            '投注人数',
            '显示该游戏筛选时间内投注人数；'
          )
        }
      },

      {
        key: 'sub_user_num',
        align: 'center',
        sortable: 'custom',
        width: 125,
        resizable: true,
        render: (h, params) => {
          return h(
            'span',
            (this as any).getCustomFixed(
              this.tableTotal.sub_user_num
                ? (params.row.sub_user_num / this.tableTotal.sub_user_num) * 100
                : 0
            ) + '%'
          )
        },
        renderHeader: (h, params) => {
          return (this as any).renderHeader(
            h,
            '投注人数占比',
            '显示该游戏投注人数的在总投注人数中的占比'
          )
        }
      },
      {
        key: 'bet_point',
        align: 'center',
        sortable: 'custom',
        width: 125,
        resizable: true,
        render: (h, params) => {
          return h(
            'span',
            (this as any).getCustomFixed(params.row.bet_point / 10000)
          )
        },
        renderHeader: (h, params) => {
          return (this as any).renderHeader(
            h,
            '投注金额',
            '筛选时间范围内该子游戏的投注金额'
          )
        }
      },
      {
        key: 'bet_point',
        align: 'center',
        sortable: 'custom',
        width: 125,
        resizable: true,
        render: (h, params) => {
          return h(
            'span',
            (this as any).getCustomFixed(
              this.tableTotal.bet_point
                ? (params.row.bet_point / this.tableTotal.bet_point) * 100
                : 0
            ) + '%'
          )
        },
        renderHeader: (h, params) => {
          return (this as any).renderHeader(
            h,
            '投注金额占比',
            '显示该游戏投注金额的在总投注金额中的占比'
          )
        }
      },
      {
        key: 'user_point',
        align: 'center',
        sortable: 'custom',
        width: 125,
        resizable: true,
        render: (h, params) => {
          return h(
            'span',
            (this as any).getCustomFixed(params.row.user_point / 10000)
          )
        },
        renderHeader: (h, params) => {
          return (this as any).renderHeader(
            h,
            '人均投注金额',
            '显示该游戏投得人均投注金额 = 投注金额/投注人数'
          )
        }
      },
      {
        key: 'play_num',
        align: 'center',
        sortable: 'custom',
        width: 125,
        resizable: true,
        renderHeader: (h, params) =>
          (this as any).renderHeader(
            h,
            '人均游戏次数',
            '筛选时间内，游戏次数/子游戏投注人数'
          )
      },
      {
        key: 'back_point',
        title: '返奖金额',
        align: 'center',
        sortable: 'custom',
        width: 125,
        resizable: true,
        render: (h, params) => {
          return h(
            'span',
            (this as any).getCustomFixed(params.row.back_point / 10000)
          )
        },
        renderHeader: (h, params) => {
          return (this as any).renderHeader(
            h,
            '返奖金额',
            '显示该游戏筛选时间内的返奖金额'
          )
        }
      },
      {
        key: 'percent_point',
        align: 'center',
        sortable: 'custom',
        width: 125,
        resizable: true,
        render: (h, params) => {
          return h(
            'span',
            (this as any).getCustomFixed(params.row.percent_point / 10000)
          )
        },
        renderHeader: (h, params) => {
          return (this as any).renderHeader(
            h,
            '税收金额',
            '筛选时间范围内该游戏带来的税收金额'
          )
        }
      },
      {
        key: 'loss_point',
        align: 'center',
        sortable: 'custom',
        width: 125,
        resizable: true,
        render: (h, params) => {
          return h(
            'span',
            (this as any).getCustomFixed(params.row.loss_point / 10000)
          )
        },
        renderHeader: (h, params) => {
          return (this as any).renderHeader(
            h,
            '游戏盈亏',
            '示该游戏筛选时间内的游戏盈亏金额；投注-返奖'
          )
        }
      },
      {
        key: 'loss_rate',
        align: 'center',
        sortable: 'custom',
        width: 125,
        resizable: true,
        render: (h, params) => {
          return h('span', (params.row.loss_rate * 100).toFixed(2) + '%')
        },
        renderHeader: (h, params) => {
          return (this as any).renderHeader(
            h,
            '盈亏投注比',
            '盈亏金额/投注金额'
          )
        }
      },
      {
        key: 'winner_rate',
        align: 'center',
        sortable: 'custom',
        width: 125,
        resizable: true,
        render: (h, params) => {
          return h('span', (params.row.winner_rate * 100).toFixed(2) + '%')
        },
        renderHeader: (h, params) => {
          return (this as any).renderHeader(
            h,
            '赢钱人数占比',
            '赢家人数/（赢家+输家人数'
          )
        }
      },
      isExpand
        ? {
            title: ' 分布图',
            align: 'center',
            minWidth: 80,
            render: (h, params) => {
              if (params.row.game_id > 0) {
                return h(
                  'Button',
                  {
                    props: {
                      size: 'small',
                      type: 'primary'
                    },
                    on: {
                      click: () => {
                        this.getImageData(params.row)
                      }
                    }
                  },
                  ' 分布图'
                )
              } else {
                return h('span', '')
              }
            }
          }
        : {
            title: ' 分布图',
            align: 'center',
            minWidth: 80
          }
    ]
  }
  widthResize(val, val1, val2) {
    let { key } = val2
    let find: any = this.table.columns1.find(el => el.key == key)
    if (find) {
      find.width = val
    }
  }
  closeTimer() {
    this.loading = false
    clearTimeout(this.TransTopReqTimer)
    this.TransTopReqTimer = null
  }
  openTimer() {
    this.closeTimer()
    this.loading = true
    this.TransTopReqTimer = setTimeout(() => {
      this.loading = false
    }, 6000)
  }
  //获取列表
  gitList() {
    if (this.loading) return
    this.table.data = []
    let list: any = []
    let paramAppArray: any = []
    let checkList: any = this.table.platCheckList
    if (checkList.length == 0) {
      if (this.table.app_ids.length == 0) {
        paramAppArray =
          (this as any).app_list.map((cur: any) => cur.appid) || []
      } else {
        paramAppArray = [...this.table.app_ids]
      }
    } else if (this.table.app_ids.length == 0) {
      ;(this as any).app_list
        .filter((el: any) => checkList.includes(el.platform))
        .reduce((res: any, cur: any) => {
          res.push(cur.appid)
          return res
        }, paramAppArray)
    } else {
      paramAppArray = [...this.table.app_ids]
    }
    let delArray = [...paramAppArray]
    if (paramAppArray) {
      this.openTimer()
      this.tableTotal.round_num = 0
      this.tableTotal.sub_user_num = 0
      this.tableTotal.bet_user_rate = 1
      this.tableTotal.bet_point = 0
      this.tableTotal.bet_point_rate = 1
      this.tableTotal.back_point = 0
      this.tableTotal.percent_point = 0
      this.tableTotal.loss_point = 0
      this.tableTotal.loss_rate = 0
      this.tableTotal.winner_rate = 0
      this.tableTotal.winner_user = 0
      this.tableTotal.loser_user = 0
      this.tableTotal.user_point = 0
      let httpList: any = []
      for (let k = 0, lens = paramAppArray.length; k < lens; k++) {
        let item = paramAppArray[k]
        let app: any = (this as any).app_list.find(
          (el: any) => el.appid == item
        )
        let appName = app ? app.name : ''
        this.table.params.stime = (this as any).getSecond(
          this.select.dataTime[0]
        )
        this.table.params.etime = (this as any).getSecond(
          this.select.dataTime[1],
          false
        )
        let param = {
          mod: 'root',
          platid: app.platform,
          app_id: item,
          appName: appName,
          param: {
            _mod: 'manager',
            _func: 'GetNewGameSubLevelInfo',
            _param: {
              ...Object.assign({}, this.table.params, {
                // platid: app.platform,
                platform: app.platform
              }),
              app_id: item
            }
          }
        }
        httpList.push(param)
      }
      let max = Math.min(5, httpList.length)
      for (let i = 0; i < max; i++) {
        this.toHttp(httpList, list)
      }
    }
  }
  toHttp(httpList, list) {
    if (httpList.length > 0) {
      let param = httpList[0]
      httpList.shift()
      let appName = param.appName
      TransTopReq(param)
        .then(res => {
          let data = res._param.data || []
          let index = list.findIndex(
            el => el.game_id == this.tableTotal.game_id
          )
          if (index != -1) list.splice(index, 1)
          if (data.length > 0) {
            this.tableTotal.winner_user += res._param.win_user || 0
            this.tableTotal.loser_user += res._param.lose_user || 0
            for (let i = 0, len = data.length; i < len; i++) {
              let el: any = data[i]
              el.play_num = Math.round(el.play_rate * 100) / 100
              this.tableTotal.sub_user_num += el.sub_user_num || 0
              this.tableTotal.bet_point += el.bet_point || 0
              this.tableTotal.back_point += el.back_point || 0
              this.tableTotal.percent_point += el.percent_point || 0
              this.tableTotal.loss_point += el.loss_point || 0
              this.tableTotal.round_num += el.round_num || 0
              this.tableTotal.bet_user_rate = this.tableTotal.sub_user_num
                ? 1
                : 0
              this.tableTotal.bet_point_rate = this.tableTotal.bet_point ? 1 : 0
              this.reCalcRate(this.tableTotal)
              this.tableTotal.play_num = this.tableTotal.sub_user_num
                ? Math.round(
                    this.tableTotal.round_num / this.tableTotal.sub_user_num
                  )
                : 0
              this.reCalcRate(el)
              el.data = el.sub_levels || []
              delete el.sub_levels
              el.data.forEach((elItem: any) => {
                elItem.play_num = Math.round(elItem.play_rate * 100) / 100
                elItem.game_name += `(${elItem.game_lv})`
                this.reCalcRate(elItem)
              })
              let item: any = list.find(
                (element: any) => element.game_id == el.game_id
              )
              if (!item) {
                list.push((this as any).copyData(el))
              } else {
                let other: any = []
                el.data.forEach((cItem: any) => {
                  let find = item.data.find(
                    (iItem: any) => iItem.game_lv == cItem.game_lv
                  )
                  if (find) {
                    this.reCalc(find, cItem)
                    this.reCalcRate(find)
                  } else {
                    other.push(cItem)
                  }
                })
                item.data = [...item.data, ...other]
                this.reCalc(item, el)
              }
            }
          }
          this.requestCallBack(httpList, list)
          this.toHttp(httpList, list)
        })
        .catch(error => {
          this.requestCallBack(httpList, list)
          this.toHttp(httpList, list)
        })
    }
  }
  reCalc(val1, val2) {
    for (let key in val1) {
      if (typeof val1[key] == 'number' && key != 'game_id') {
        val1[key] += val2[key]
      }
    }
    this.reCalcRate(val1)
  }
  reCalcRate(val1) {
    val1.user_point = (this as any).calcRate(val1.bet_point, val1.sub_user_num)
    val1.loss_rate = (this as any).calcRate(val1.loss_point, val1.bet_point)
    val1.winner_rate = (this as any).calcRate(
      val1.winner_user,
      val1.winner_user + val1.loser_user
    )
    val1.play_num = (this as any).calcRate(
      val1.round_num,
      val1.sub_user_num,
      true
    )
  }
  requestCallBack(list: any, tableData: any) {
    let index = tableData.findIndex(el => el.game_id == this.tableTotal.game_id)
    if (index != -1) tableData.splice(index, 1)
    if (tableData.length > 0) {
      tableData.push((this as any).copyData(this.tableTotal))
      this.table.data = tableData
    }
    if (list.length == 0) {
      this.closeTimer()
    }
  }
  expandId: any
  onExpand(row, status) {
    this.expandId = row.game_id
    let expand = this.table.data.find((el: any) => el._expanded)
    if (expand) this.$set(expand, '_expanded', false)
    if (status) {
      let newEx = this.table.data.find((el: any) => el.game_id == row.game_id)
      if (newEx) this.$set(newEx, '_expanded', true)
    }
  }
  handleTableClick(row, index) {
    let data: any = this.table.data[index]
    if (this.expandId == row.game_id) {
      if (!data._expanded) this.expandId = null
    } else {
      ;(this.table.data[index]['_userCheck'] as any) = !data._userCheck
    }
  }
  rowClassName(row, index) {
    let data: any = this.table.data[index]
    return data._userCheck || data._expanded ? 'user-table-check' : ''
  }
  sortChange(params) {
    let find: any = this.table.data.find((el: any) => el._expanded)
    if (find) find._expanded = false
    let order = params.order == 'desc' ? 1 : -1
    let key = params.key
    this.table.data.sort((a: any, b: any) => {
      if (a.game_id == -10) return 1
      if (b.game_id == -10) return -1
      return a[key] * order > b[key] * order ? -1 : 1
    })
  }

  getImageData(param: any) {
    this.imageData.checkColumn = 'sub_user_num'
    this.imageData.chartData.columns = ['game_name', 'sub_user_num']
    let rows = (this as any).copyData(param.data)
    rows.forEach((el: any) => {
      el.bet_point_rate = (this as any).calcRate(
        el.bet_point,
        this.tableTotal.bet_point
      )
      el.bet_user_rate = (this as any).calcRate(
        el.sub_user_num,
        this.tableTotal.sub_user_num
      )
      for (let i in el) {
        if (i.includes('_point') && !i.includes('_rate')) {
          el[i] = (this as any).getCustomFixed(el[i] / 10000)
        }
      }
    })
    this.sort(rows, 'sub_user_num')
    this.imageData.chartData.rows = rows
    this.imageData.show = true
    this.imageData.app_name = param.game_name
    this.$nextTick(() => {
      ;(this.$refs[this.imageData.ref] as any).echarts.resize()
    })
  }
  sort(list, val) {
    list.sort((a, b) => {
      return parseFloat(a[val]) > parseFloat(b[val]) ? 1 : -1
    })
  }
  imageIndexChange(val) {
    this.imageData.chartData.columns = [
      this.imageData.chartData.columns[0],
      val
    ]
    this.sort(this.imageData.chartData.rows, val)
    ;(this.$refs[this.imageData.ref] as any).echarts.resize()
  }
  getChartSetting() {
    if (this.imageData.checkColumn.includes('_rate')) {
      return this.imageData.chartSettings
    } else {
      return Object.assign({}, this.imageData.chartSettings, {
        yAxisType: ['normal']
      })
    }
  }
  // 分布图时间
  getSearchData(isStart: Boolean = true) {
    return `(${moment(this.table.params.stime * 1000)
      .locale('zh-cn')
      .format('YYYY/MM/DD')} - ${moment(this.table.params.etime * 1000)
      .locale('zh-cn')
      .format('YYYY/MM/DD')})`
  }
  created() {
    this.gitList()
  }
}
